//
//
//
//

import { modelData } from '@/utils/mqtt'

export default {
    props: {
        propValue: {
            type: String,
            require: true,
            default: '',
        },
        element: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            modelData,
        }
    },
}
